// @ts-nocheck
import { BAT_FILTERS_CHANGED, BAT_ITEM_RECEIVED, BAT_LIST_RECEIVED } from '../types';

const initialState = {
    list: [],
    current: null,
    filters: {
        keyword: '',
    },
    currentType: '',
};

const bat = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case BAT_LIST_RECEIVED: {
            return {
                ...state,
                list: payload,
            };
        }
        case BAT_ITEM_RECEIVED: {
            return {
                ...state,
                current: payload.item,
                currentType: payload.type,
            };
        }
        case BAT_FILTERS_CHANGED: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...payload,
                },
            };
        }
        default: {
            return state;
        }
    }
};

export default bat;
